import { BUTTON_VARIANTS } from 'ui/button';
import { Logout } from 'ui/icons/navigation/Logout';
import { colors } from 'ui/theme';
import { FooterLink } from '../FooterLink';
import { FooterWrapper } from '../styles';
import { LinksWrapper, StyledLinkButton } from './AccountsAndProjectsMenu.styles';

export const FOOTER_LINKS = [
  {
    label: 'Anti-Spam Policy',
    href: 'https://iterable.com/anti-spam-policy/',
  },
  {
    label: 'Terms',
    href: 'https://iterable.com/terms',
  },
  {
    label: 'Privacy',
    href: 'https://iterable.com/privacy-policy',
  },
];

export const FOOTER_TEXT = {
  SIGN_OUT: 'Sign out',
};

export const Footer = () => {
  return (
    <FooterWrapper data-test="profile-footer">
      <StyledLinkButton isAngular to="/logout" variant={BUTTON_VARIANTS.SECONDARY}>
        <Logout color={colors.secondaryText} />
        <div>{FOOTER_TEXT.SIGN_OUT}</div>
      </StyledLinkButton>
      <LinksWrapper>
        {FOOTER_LINKS.map((link, index) => (
          <FooterLink key={index} {...link} />
        ))}
      </LinksWrapper>
    </FooterWrapper>
  );
};
